import { classes } from 'html-classes';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { company } from '~/company/Company';
import { Button } from '~/components/isolated/Button';

import styles from './CatalogButton.module.scss';
import { SuperMenu } from './components/SuperMenu';

export const CatalogButton: React.FC<{ isTablet?: boolean }> = ({
  isTablet,
}) => {
  const { t } = useTranslation();
  const [showSuperMenu, setShowSuperMenu] = useState(false);
  const navigate = useNavigate();

  const buttonRef = useRef<Nullable<HTMLButtonElement>>(null);

  const handleCatalogToggle = () => {
    if (company.isMarketplaceVariant) {
      navigate('/shop');
      return;
    }

    setShowSuperMenu((prev) => !prev);
  };

  const handleCloseSuperMenu = () => {
    setShowSuperMenu(false);
  };

  return (
    <>
      <Button
        endIcon="catalog-3.1"
        size="M"
        variant="brand"
        onClick={handleCatalogToggle}
        ref={buttonRef}
        className={classes([
          isTablet ? styles.shortBtn : undefined,
          company.isMarketplaceVariant ? styles.btnMarketplace : undefined,
        ])}
      >
        {!isTablet && t('header:catalog')}
      </Button>

      <SuperMenu
        isOpen={showSuperMenu}
        onClose={handleCloseSuperMenu}
        buttonRef={buttonRef}
      />
    </>
  );
};
